import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateServiceModule } from '../translate-service/translate-service.module';
import { FloatLabelModule } from '../float-label/float-label.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateServiceModule,
    FloatLabelModule
  ],
  exports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateServiceModule,
    FloatLabelModule
  ]
})
export class CommonSharedModule { }
